export enum ProjectStatus {
  Prospect = 1,
  Quote = 2,
  POReceived = 3,
  Cancelled = 4,
  Imported = 5
}
